<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option>{{ overrideEmptyOption !== '' ? overrideEmptyOption : '' }}</lcs-option>
      } @for (extension of extensions | async; track trackBy(extension)) {
      <lcs-option [value]="extension" id="lcs-option-id-{{ extension.extensionId }}">
         {{ extension.number >= 0 ? extension.number + '-' : '' }} {{ extension.name }}
      </lcs-option>
      }
   </div>
</ng-template>
